import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createContext, useContext, useCallback, useState, useRef } from "react";
import defaultUser from "@authentication/constants/defaultUser.json";
import { fetchUser } from "@authentication/api";
import userAccess from "@authentication/utils/userAccess";
import { logoutEventName, loginEventName } from "@authentication/utils/events";
import useCustomEffect from "hooks/useCustomEffect";
import { jsx as _jsx } from "react/jsx-runtime";
export var AuthContext = /*#__PURE__*/createContext({});
export var AuthContextProvider = function AuthContextProvider(props) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    inMemoryUser = _useState2[0],
    setInMemoryUser = _useState2[1];
  var refreshTimeOutId = useRef();
  var getUser = useCallback(function () {
    return inMemoryUser;
  }, [inMemoryUser]);
  var getUserAccess = function getUserAccess() {
    var _getUser;
    return (_getUser = getUser()) !== null && _getUser !== void 0 && _getUser.ticket ? userAccess(getUser()) : {};
  };
  var abortRefreshUser = useCallback(function () {
    if (refreshTimeOutId.current) window.clearTimeout(refreshTimeOutId);
  }, []);
  var eraseUser = useCallback(function () {
    abortRefreshUser();
    setInMemoryUser(defaultUser);
    return true;
  }, [abortRefreshUser]);
  var setUser = useCallback(function (user) {
    //refresh the token before it's no longer valid.
    refreshTimeOutId.current = window.setTimeout(function () {
      return fetchUser(eraseUser, setUser);
    }, 900 * 1000 - 5000);
    setInMemoryUser(user);
    return true;
  }, [eraseUser]);
  var handleStorageEvent = useCallback(function (event) {
    var _getUser2;
    if (event.key === logoutEventName) eraseUser(defaultUser);else if (event.key === loginEventName && !((_getUser2 = getUser()) !== null && _getUser2 !== void 0 && _getUser2.ticket)) fetchUser(eraseUser, setUser);
  }, [getUser, eraseUser, setUser]);
  useCustomEffect(function () {
    fetchUser(eraseUser, setUser);
    window.addEventListener("storage", handleStorageEvent);
    return function () {
      window.removeEventListener("storage", handleStorageEvent);
    };
  }, []);
  if (!getUser()) return null;
  return /*#__PURE__*/_jsx(AuthContext.Provider, _objectSpread({
    value: {
      reFetchUser: function reFetchUser() {
        return fetchUser(eraseUser, setUser);
      },
      getUser: getUser,
      getUserAccess: getUserAccess
    }
  }, props));
};
export var useAuthContext = function useAuthContext() {
  return useContext(AuthContext);
};